// Generated types for ActionDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLBehaviorReadAPI, SysMLBehaviorWriteAPI } from './sysmlbehavior';
import { SysMLBehaviorReadAPISchemaObject, SysMLBehaviorWriteAPISchemaObject } from './sysmlbehavior';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionDefinitionReadAPI extends SysMLBehaviorReadAPI {
}

export interface ActionDefinitionWriteAPI extends SysMLBehaviorWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionDefinitionReadAPISchemaObject = SysMLBehaviorReadAPISchemaObject.extend({}).passthrough();
export const ActionDefinitionReadAPISchema: z.ZodType<ActionDefinitionReadAPI> = ActionDefinitionReadAPISchemaObject;

export const ActionDefinitionWriteAPISchemaObject = SysMLBehaviorWriteAPISchemaObject.extend({}).passthrough();
export const ActionDefinitionWriteAPISchema: z.ZodType<ActionDefinitionWriteAPI> = ActionDefinitionWriteAPISchemaObject;
